import { stateDate } from "./formatDate";
import { startOfMonth, subMonths } from "date-fns";

const colorsList = [
  '#a6d789',
  '#f0d063',
  '#e53325',
  '#6a6a6a',
  '#b2c88a',
  '#ffdf77',
  '#f74a3f',
  '#c5da9d',
  '#ffedd0',
  '#ff776c',
  '#35a2eb',
  '#ff5b00',
  '#c6c3b5',
  '#99a2eb',
  '#5c9208',
  '#62c3b5',
  '#ffce56',
  '#c04b6c',
  '#ff6384',
  '#369eef',
  '#9966ff',
  '#ff4747',
  '#4bc0c0',
  '#ff7f50',
  '#9370db',
  '#f08080',
  '#add8e6',
  '#90ee90',
  '#ff8c00',
  '#ffe4c4',
];

export const groupList = ["subgroup", "group", "category", "subcategory", "sku", "pos", "chain", "action"];

export let backgroundColorOptions = [...colorsList];

export const addMutedColors = () => {
  const colors = [];
  for (let i = 0; i < 1000; i++) {
    const r = Math.floor(Math.random() * 256);
    const g = Math.floor(Math.random() * 256);
    const b = Math.floor(Math.random() * 256);

    const color = `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
    colors.push(color);
  }

  backgroundColorOptions = [...colorsList, ...colors];
};

export const defaultFilter = {
  fromDate: stateDate(startOfMonth(subMonths(new Date(), 0))),
  group: { value: '3', label: 'По сети' },
  toDate: stateDate(new Date()),
};

export const optionsDefault = [
  { label: 'Руб', value: 0 },
  { label: 'Шт', value: 1 },
];

export const periodOptions = [
  { value: '0', label: 'Группировать по дням' },
  { value: '7', label: 'Группировать по неделям' },
  { value: '8', label: 'Группировать по месяцам' },
  { value: '9', label: 'Группировать по годам' },
];

export const skuOptions = [
  { value: '10', label: 'Категория товара' },
  { value: '11', label: 'Подкатегория товара' },
  { value: '13', label: 'Группа товара' },
  { value: '14', label: 'Подгруппа товара' }
];

export const monthOptions = [
  { value: '01', label: 'Январь' },
  { value: '02', label: 'Февраль' },
  { value: '03', label: 'Март' },
  { value: '04', label: 'Апрель' },
  { value: '05', label: 'Май' },
  { value: '06', label: 'Июнь' },
  { value: '07', label: 'Июль' },
  { value: '08', label: 'Август' },
  { value: '09', label: 'Сентябрь' },
  { value: '10', label: 'Октябрь' },
  { value: '11', label: 'Ноябрь' },
  { value: '12', label: 'Декабрь' },
];

export const lineList = ['lineBar', 'lineBarStacked', 'lineBarNorm'];
export const lineChartList = ['lineChart', 'lineChartStacked', 'lineChartStackedNorm'];
export const normList = ['barStackedNorm', 'lineBarNorm', 'lineChartStackedNorm'];
export const reverseChartsList = ['barStackedNorm', 'barStacked'];
export const tickData = {
  font: {
    family: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
  },
};

export const createFormatDateFunction = (options: any) => (data: string) => {
  const regex = /^\d{4}-(0[1-9]|1[0-2])$/;
  if (!regex.test(data)) {
    const findItem = options && options.find((el: { value: number, label: string }) => el.value === parseFloat(data));
    return findItem?.label;
  } else {
    const [year, month] = data.split('-');
    const findItem = options && options.find((el: { value: string, label: string }) => el.value === month);
    return `${findItem?.label || ''} ${year}`;
  }
};

export const isChangeData = (data: { [key: string]: any }) => { return JSON.stringify(defaultFilter) !== JSON.stringify(data) };

export const getSortedValue = (arr?: any) => {
  const sortlist = arr.slice().sort((a: { value: string | number, label: string }, b: { value: string | number, label: string }) =>
    a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
  const sortedValues = sortlist.map((item: { value: string | number, label: string }) => item.value);
  return sortedValues;
};

export const filteredZeroData = (data: any) => {
  const filteredData = data.map((el: any) => {
    const zeroArray = el.data.every((value: string | null | number) => value === '0' || value === 0 || value === null);
    return !zeroArray ? el : null;
  });

  const dataArr = filteredData.filter((el: any) => el !== null).map((el: any) => { return el.label });

  return dataArr;
};

export const getColorOptions = (setting: string[]) => {
  return setting
    ? [...setting, ...backgroundColorOptions.slice(setting.length)]
    : backgroundColorOptions;
};

export const adjustValuesToHundred=(values: number[]): number[]=> {
  const roundedValues = values.map(value => Math.round(value));
  const total = roundedValues.reduce((sum, val) => sum + val, 0);

  let diff = 100 - total;

  if (diff !== 0) {
    const sortedIndices = values
      .map((value, index) => ({ value, index }))
      .sort((a, b) => (diff > 0 ? b.value % 1 - a.value % 1 : a.value % 1 - b.value % 1))
      .map(item => item.index);

    for (let i = 0; i < Math.abs(diff); i++) {
      roundedValues[sortedIndices[i]] += diff > 0 ? 1 : -1;
    }
  }

  return roundedValues;
};
